import { IMediaAndContent } from '../../interfaces/MediaAndContent';
import { API_FILES_BASE_URL } from '../../utils/const';
import MediaAndContentWithDownload from '../Cards/MediaAndContentWithDownload';

interface IMediaAndContentMapper {
    data: IMediaAndContent[] | null;
}

const MediaAndContentMapperResearch = ({ data }: IMediaAndContentMapper) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="my-12 grid grid-cols-1 xl:grid-cols-2 gap-8 justify-items-center xl:justify-items-start">
            {data.map((renderContent) => {
                const shareUrl = `${window.location.origin}/monitor/informes?id=${renderContent.id}`;
                return (
                    <MediaAndContentWithDownload
                        key={renderContent.id}
                        id={renderContent.id}
                        imagen={`${API_FILES_BASE_URL}${renderContent.imagen.replace("files/", "")}`}
                        titulo={renderContent.titulo}
                        descripcion={renderContent.descripcion}
                        fecha={renderContent.fecha}
                        categorias={renderContent.categorias}
                        pdf={renderContent.pdf}
                        url={shareUrl}
                    />
                );
            })}
        </div>
    );
};

export default MediaAndContentMapperResearch;